// CustomLoadingIndicator.js

import React from 'react';
import styled from 'styled-components';
import 'three-dots/dist/three-dots.css';

// Styled component to customize the dot-pulse animation
const CustomDotPulse = styled.div`
  &.dot-pulse {
      color: ${({brandTheme}) => brandTheme?.general?.buttons?.backgroundColor};
      width: 3px;
      height: 3px;
      margin-top: 5px;
  }

  &.dot-pulse::before,
  &.dot-pulse::after {
    color: ${({brandTheme}) => brandTheme?.general?.buttons?.backgroundColor};
      width: 3px;
      height: 3px;
  }
`;

const ThinkingIndicator = ({brandTheme}) => (
    <CustomDotPulse className="dot-pulse" brandTheme={brandTheme} />
);

export default ThinkingIndicator;
